import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { Button } from '../components/Button';
import { ConfiguredForm } from '../components/ConfiguredForm';
import { candidateFormConfig } from '../data/forms';
import { candidateShareItems, candidateSteps, images } from '../data/content';
import { contactEmail } from '../data/navigation';
export function Candidates() {
  return <>
      <PageHeader label="Career Opportunities" title="Your experience deserves the right opportunity." intro="We welcome expressions of interest from experienced professionals who would like to be considered for relevant senior and leadership opportunities aligned with their experience and career goals." image={{
      src: images.candidate,
      alt: 'An experienced professional reviewing notes in a bright office'
    }} actions={<Button href="#register" data-id="element-345" data-mp="1urf2o4dzbuhr">Register Your Interest</Button>} data-id="element-344" data-mp="1gr4ej9420u0a" />

      <section aria-labelledby="how-heading" className="bg-white py-24 lg:py-28" data-id="element-346" data-mp="1cqgrjbgq82g0">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-347" data-mp="1cst93nikoasj">
          <Reveal className="max-w-2xl" data-id="element-348" data-mp="1ho8km8t3xuls">
            <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-349" data-mp="1hrebntlar6k5" />
            <h2 id="how-heading" className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-350" data-mp="13049bpwdwld1">
              How registering works
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink/75" data-id="element-351" data-mp="tyxr9ce372ho">
              Rather than listing vacancies here, we invite professionals to register their
              interest and share the kind of role they’re looking for.
            </p>
          </Reveal>
          <ol className="mt-14 grid gap-10 md:grid-cols-3 md:gap-12" data-id="element-352" data-mp="p0w68lx3ot3k">
            {candidateSteps.map((step, i) => <li key={step.title} data-id="element-353" data-mp="2efklqw0zmr5t" data-mpi={i}>
                <Reveal delay={i * 0.05} className="border-t border-gold/50 pt-6" data-id="element-354" data-mp="2egc95jkflil0">
                  <p className="font-serif text-2xl font-medium text-ink/50" data-id="element-355" data-mp="2jdm57i2bssht">0{i + 1}</p>
                  <h3 className="mt-2 font-serif text-[26px] font-medium leading-tight text-navy" data-id="element-356" data-mp="2hyrqq8cdjibw">{step.title}</h3>
                  <p className="mt-3 leading-relaxed text-ink/70" data-id="element-357" data-mp="2cxvlnrgadq4w">{step.body}</p>
                </Reveal>
              </li>)}
          </ol>
          <p className="mt-12 max-w-2xl text-sm leading-relaxed text-ink/60" data-id="element-358" data-mp="23y8lta37gsdy">
            Registering interest does not guarantee consideration for a specific role, an
            interview, or a placement.
          </p>
        </div>
      </section>

      <section id="register" className="scroll-mt-24 bg-mist py-24 lg:py-32" data-id="element-359" data-mp="2vpojbz6avziy">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10" data-id="element-360" data-mp="2qxd7bxyacna1">
          <Reveal className="lg:col-span-5" data-id="element-361" data-mp="2mvrycnovgt54">
            <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-362" data-mp="2muqm4fw4e0lt" />
            <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-363" data-mp="3jgaewqz4brc2">
              Register your interest
            </h2>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-ink/75" data-id="element-364" data-mp="115wdjo76w5j6">
              Tell us about your experience and the opportunities you would consider.
            </p>
            <div className="mt-10 max-w-md" data-id="element-365" data-mp="1a619n26xnhi1">
              <p className="text-sm font-medium text-ink" data-id="element-366" data-mp="1a500j39h952y">Helpful details to share</p>
              <ul className="mt-3 divide-y divide-ink/10 border-y border-ink/10" data-id="element-367" data-mp="1f5e68enlw2xt">
                {candidateShareItems.map(item => <li key={item} className="flex items-center gap-4 py-3.5 text-[15px] text-ink/75" data-id="element-368" data-mp="1k3yxvposlean">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-369" data-mp="1p1hapr5xkdnx" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <p className="mt-8 text-sm text-ink/70" data-id="element-370" data-mp="1xxq70wym2w5u">
              Prefer to send your CV by email?{' '}
              <a href={`mailto:${contactEmail}`} className="font-medium text-navy underline decoration-gold underline-offset-4" data-id="element-371" data-mp="22sm2y86yy3o8">
                {contactEmail}
              </a>
            </p>
          </Reveal>
          <div className="lg:col-span-7" data-id="element-372" data-mp="1p7zpxpnngpbw">
            <ConfiguredForm config={candidateFormConfig} data-id="element-373" data-mp="1p6yfnnegk6v8" />
          </div>
        </div>
      </section>
    </>;
}